import { createSlice } from '@reduxjs/toolkit'
import { BUSINESS_VERTICAL_ENERGY } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

const initialState = {
  mode: 'net',
  providerUuid: null,
  podsText: '',
  isSubmitting: false,
  resultError: null,
  resultMessage: null,
  providers: [],
  isProvidersLoading: false,
  providersError: null,
  // By default, once we allow other countries and business type we put in null
  businessType: BUSINESS_VERTICAL_ENERGY,
  country: 'fr',
}

const setModeHandler = (state, { payload }) => {
  state.mode = payload === 'abandon' ? 'abandon' : 'net'
}

const setProviderUuidHandler = (state, { payload }) => {
  state.providerUuid = payload ? String(payload) : null
}

const setPodsTextHandler = (state, { payload }) => {
  state.podsText = String(payload ?? '')
}

const setBusinessTypeHandler = (state, { payload }) => {
  state.businessType = payload ? String(payload) : null
  state.providerUuid = null
}

const setCountryHandler = (state, { payload }) => {
  state.country = payload ? String(payload) : null
  state.providerUuid = null
}

const submitRequestHandler = state => {
  state.isSubmitting = true
  state.resultError = null
  state.resultMessage = null
}

const submitSuccessHandler = (state, { payload }) => {
  state.isSubmitting = false
  state.resultError = null
  state.resultMessage = payload?.message || ''
}

const submitFailureHandler = (state, { payload }) => {
  state.isSubmitting = false
  state.resultError = payload?.error || 'Error'
  state.resultMessage = payload?.message || null
}

const fetchProvidersRequestHandler = state => {
  state.isProvidersLoading = true
  state.providersError = null
}

const fetchProvidersSuccessHandler = (state, { payload }) => {
  state.isProvidersLoading = false
  state.providers = Array.isArray(payload) ? payload : []
  state.providersError = null
}

const fetchProvidersFailureHandler = (state, { payload }) => {
  state.isProvidersLoading = false
  state.providersError = payload || 'Error'
}

const resetHandler = state => {
  Object.assign(state, initialState)
}

const slice = createSlice({
  name: 'podUpdaterTools',
  initialState,
  reducers: {
    setMode: setModeHandler,
    setProviderUuid: setProviderUuidHandler,
    setPodsText: setPodsTextHandler,
    setBusinessType: setBusinessTypeHandler,
    setCountry: setCountryHandler,
    submitRequest: submitRequestHandler,
    submitSuccess: submitSuccessHandler,
    submitFailure: submitFailureHandler,
    fetchProvidersRequest: fetchProvidersRequestHandler,
    fetchProvidersSuccess: fetchProvidersSuccessHandler,
    fetchProvidersFailure: fetchProvidersFailureHandler,
    reset: resetHandler,
  },
})

export const {
  setMode,
  setProviderUuid,
  setPodsText,
  setBusinessType,
  setCountry,
  submitRequest,
  submitSuccess,
  submitFailure,
  fetchProvidersRequest,
  fetchProvidersSuccess,
  fetchProvidersFailure,
  reset,
} = slice.actions

export default slice.reducer
